import React from "react";
import Page from "../../Containers/Reports/Page";
import { PALLETTE } from "../../utils/theme";

interface AssessmentNotDoneWrapperProps {
  children?: React.ReactNode;
}

const AssessmentNotDoneWrapper = ({
  children,
}: AssessmentNotDoneWrapperProps) => {
  return (
    <Page
      style={{
        height: "85svh",
        flexDirection: "column",
      }}
    >
      <div> {children}</div>

      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "2rem",
          textAlign: "center",
          gap: "0.75rem",
        }}
      >
        <div
          style={{
            fontSize: "4rem",
            marginBottom: "0.5rem",
          }}
        >
          📋
        </div>

        <h2
          style={{
            fontSize: "2rem",
            fontWeight: 600,
            color: PALLETTE.dark,
            margin: 0,
          }}
        >
          Assessment Not Completed
        </h2>

        <p
          style={{
            fontSize: "1.5rem",
            color: PALLETTE.gray,
            margin: 0,
            maxWidth: "28rem",
            lineHeight: 1.5,
          }}
        >
          The assessment has not been completed yet. Please complete the
          assessment to view the health report.
        </p>
      </div>
    </Page>
  );
};

export default AssessmentNotDoneWrapper;
